import { validateWebEnv } from "@fleetminder/config";

export function loadBrowserEnvironment(
  source: Record<string, string | undefined> = import.meta.env,
): ReturnType<typeof validateWebEnv> {
  return validateWebEnv({
    VITE_API_BASE_URL: source["VITE_API_BASE_URL"] ?? "http://localhost:3001",
    VITE_APP_ENV: source["VITE_APP_ENV"] ?? "development",
  });
}
